import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { Toaster } from "react-hot-toast";
import Home from './pages/Home';
import SupportForm from './pages/SupportForm';
import DeleteAccount from './pages/DeleteAccount'; 

function App() {
  return (
    <>
    <Toaster position="top-center" reverseOrder={false} />
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/support" element={<SupportForm />} />
        {/* <Route path="/" element={
          <div style={{ padding: '2rem' }}>
            <h1>Welcome to Footfall</h1>
            <p>This is the homepage.</p>
          </div>
        } /> */}
      </Routes>
    </Router>
    </>
  );
}

export default App;
